import { render, staticRenderFns } from "./majorEquipment.vue?vue&type=template&id=fdfe4ef6&scoped=true&"
import script from "./majorEquipment.vue?vue&type=script&lang=js&"
export * from "./majorEquipment.vue?vue&type=script&lang=js&"
import style0 from "./majorEquipment.vue?vue&type=style&index=0&id=fdfe4ef6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfe4ef6",
  null
  
)

export default component.exports